/**
 * Utility functions for handling file downloads
 */

interface DownloadFileParams {
  response: any;
  documentId?: string;
  fileName?: string;
  defaultFileName?: string;
}

/**
 * Handles file download from API response with proper filename extraction
 */
export const downloadFile = ({ 
  response, 
  documentId, 
  fileName, 
  defaultFileName = "document" 
}: DownloadFileParams): void => {
  const contentType = response.headers["content-type"];
  const contentDisposition = response.headers["content-disposition"];
  let downloadFileName = defaultFileName;

  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(
      /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
    );
    downloadFileName =
      fileNameMatch?.[1]?.replaceAll('"', "") || downloadFileName;
  } else if (fileName) {
    downloadFileName = fileName;
  } else {
    const extension = contentType?.split("/")[1] || "bin";
    const suffix = documentId ? `-${documentId}` : "";
    downloadFileName = `${defaultFileName}${suffix}.${extension}`;
  }

  const blob = new Blob([response.data], { type: contentType });
  const downloadUrl = globalThis.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = downloadFileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
};
